import { a38 } from "../Components/Api/RootApiPath";

export const fetchAllOrders = async () => {
  try {
    const response = await fetch(a38, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    });

    if (!response.ok) {
      throw new Error(`${response.statusText || "Failed to fetch all stock list"}`);
    }

    const data = await response.json();

    const rcvdData = data.data.reverse();
    return rcvdData.map((order, index) => ({
      ...order,
      srno: index + 1,
    }));
  } catch (e) {
    // console.log(e);
    throw new Error(`${"Failed to fetch all stock list, try again later"}`);
  }
};